/** The app version from package.json; "dev" where the code runs without build.mjs (tests). */
export const APP_VERSION: string = typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "dev";
